export default {
  root: {
    display: 'flex',
    alignItems: 'start',
    justifyContent: 'center',
    flexDirection: 'column',
    height: '52px',
    width: '53px',
    pb: '4px',
    pr: '5px',
  },
  logoContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
  },
  logo: {
    height: '48px',
    objectFit: 'cover',
    width: '48px',
  },
  editButton: {
    position: 'absolute',
    bottom: '-4px',
    right: '-5px',
    width: '24px',
    height: '24px',
    backgroundColor: 'background.brand.color_2',
    color: 'white',
    p: 0,
    '&:hover': {
      backgroundColor: 'background.brand.color_2',
    },
    '&:before': {
      content: '""',
      position: 'absolute',
      left: '-2px',
      top: '-2px',
      height: 'calc(100% + 4px)',
      width: 'calc(100% + 4px)',
      backgroundColor: 'transparent',
      border: '2px solid',
      borderColor: 'background.white',
      borderRadius: '50%',
    },
  },
};
